<template>
	<v-dialog v-model="dialog" max-width="800px" persistent>
		<v-card>
			<v-card-title class="result-title">
				<s-toolbar label="TAREAS ACTIVAS EN PROCESO" dark color="#3f51b5" close
					@close="dialog = false"></s-toolbar>
			</v-card-title>
			<v-card-text>
				<v-data-table item-key="TskID" :headers="headerTasksProcess" :items="tictaStatusList"
					:items-per-page="10" dense>
					<template v-slot:[`item.TskDate`]="{ item }">
						{{ $fun.formatDateTimeView(item.TskDate) }}
					</template>
					<template v-slot:[`item.TskStatusList`]="{ item }">
						<v-chip x-small black :color="item.TskStatusColor" style="color: white;">
							{{ item.TskStatusName }}
						</v-chip>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';

export default {
    name: 'TaskActiveProcessModal',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tictaStatusList: [],
            headerTasksProcess: [
                { text: "ID", value: "TskID" },
                { text: "Titulo", value: "TskTitle" },
                { text: "Descripción", value: "TskDescription" },
                { text: "Responsable", value: "WorkerName" },
                { text: "Cargo", value: "PstName" },
                { text: "Proyecto", value: "TkpTitle" },
                { text: "Fecha Creación", value: "TskDate" },
                { text: "Estado", value: "TskStatusList" },
            ]
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                this.getTictaskStaList();
            }
        }
    },
    methods: {
        getTictaskStaList() {
            let obj = {
                TskStatus: 2,
                UsrID: this.$fun.getUserID()
            };
            _sTaskService.tictaskBystatusTask(obj, this.$fun.getUserID()).then(resp => {
                if (resp && resp.status == 200) {
                    this.tictaStatusList = resp.data;
                }
            });
        }
    }
};
</script>
<style scoped>
.result-title {
	background-color: #3f51b5;
	color: white;
	padding: 16px 24px;
	font-weight: bold;
	border-bottom: 2px solid #fff;
	border-radius: 4px 4px 0 0;
	margin-bottom: 15px;
}
</style>
